<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShow)="onShow()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  header="Create Container Case"
  [style]="{ width: 'min(1240px, 96vw)' }"
  [breakpoints]="{ '1100px': '96vw', '760px': '98vw' }"
  styleClass="delivery-container-case-dialog">
  <div class="delivery-container-case-layout">
    <aside class="delivery-container-case-summary">
      <span class="delivery-container-case-summary-icon"><i class="pi pi-truck"></i></span>
      <div>
        <small>Delivery execution</small>
        <h3>{{ deliveryNumber || 'Selected delivery' }}</h3>
        <p>The delivery remains the first transport step. Shipment, release, and execution references stay on that step.</p>
      </div>
      <div class="delivery-container-case-facts">
        <div><span>Shipment</span><strong>{{ shipmentNumber || '-' }}</strong></div>
        <div><span>Release</span><strong>{{ releaseNumber || 'Pending' }}</strong></div>
        <div><span>Route</span><strong>{{ routeLabel || 'Origin to destination' }}</strong></div>
      </div>
    </aside>

    <section class="delivery-container-case-form">
      <div class="delivery-container-case-guidance">
        <i class="pi pi-info-circle"></i>
        <span>Shipment execution ownership stays on the seeded transport leg. The Container Case remains the lifecycle envelope.</span>
      </div>

      <div class="delivery-container-case-section">
        <div class="delivery-container-case-section-title"><i class="pi pi-box"></i><span>Container identity</span></div>
        <div class="delivery-container-case-form-grid three-columns">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="deliveryCaseContainerNumber" [(ngModel)]="form.containerNumber" />
              <label for="deliveryCaseContainerNumber">Container number *</label>
            </p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="deliveryCaseEquipmentType" [options]="equipmentTypeOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.isoEquipmentType" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
              <label for="deliveryCaseEquipmentType">Equipment type</label>
            </p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-lock"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="deliveryCaseSeal" [(ngModel)]="form.sealNumber" />
              <label for="deliveryCaseSeal">Seal number</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </div>

      <div class="delivery-container-case-section">
        <div class="delivery-container-case-section-title"><i class="pi pi-file"></i><span>Commercial references</span></div>
        <div class="delivery-container-case-section-hint" [class.is-complete]="hasCommercialReference()">
          <i class="pi" [class.pi-check-circle]="hasCommercialReference()" [class.pi-info-circle]="!hasCommercialReference()"></i>
          <span>Enter at least one: bill of lading or booking number.</span>
        </div>
        <div class="delivery-container-case-form-grid two-columns">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-autoComplete inputId="deliveryCaseBl" [(ngModel)]="form.billOfLadingNumber" [suggestions]="referenceSuggestions.BILL_OF_LADING"
                optionLabel="value" optionValue="value" [dropdown]="true" [forceSelection]="false" [minLength]="0" appendTo="body" styleClass="w-full"
                (completeMethod)="searchReferences('BILL_OF_LADING', $event.query)" (onSelect)="applyReferenceSuggestion($event.value)">
                <ng-template let-reference pTemplate="item">
                  <div class="delivery-container-reference-option">
                    <strong>{{ reference.value }}</strong>
                    <small>{{ reference.bookingNumber || reference.houseBillNumber || 'Existing bill of lading' }}</small>
                  </div>
                </ng-template>
              </p-autoComplete>
              <label for="deliveryCaseBl">Bill of lading *</label>
            </p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-bookmark"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-autoComplete inputId="deliveryCaseBooking" [(ngModel)]="form.bookingNumber" [suggestions]="referenceSuggestions.BOOKING"
                optionLabel="value" optionValue="value" [dropdown]="true" [forceSelection]="false" [minLength]="0" appendTo="body" styleClass="w-full"
                (completeMethod)="searchReferences('BOOKING', $event.query)" (onSelect)="applyReferenceSuggestion($event.value)">
                <ng-template let-reference pTemplate="item">
                  <div class="delivery-container-reference-option">
                    <strong>{{ reference.value }}</strong>
                    <small>{{ reference.billOfLadingNumber || reference.houseBillNumber || 'Existing booking reference' }}</small>
                  </div>
                </ng-template>
              </p-autoComplete>
              <label for="deliveryCaseBooking">Booking number *</label>
            </p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-copy"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-autoComplete inputId="deliveryCaseHouseBl" [(ngModel)]="form.houseBillNumber" [suggestions]="referenceSuggestions.HOUSE_BILL"
                optionLabel="value" optionValue="value" [dropdown]="true" [forceSelection]="false" [minLength]="0" appendTo="body" styleClass="w-full"
                (completeMethod)="searchReferences('HOUSE_BILL', $event.query)" (onSelect)="applyReferenceSuggestion($event.value)">
                <ng-template let-reference pTemplate="item">
                  <div class="delivery-container-reference-option">
                    <strong>{{ reference.value }}</strong>
                    <small>{{ reference.billOfLadingNumber || reference.bookingNumber || 'Existing house bill' }}</small>
                  </div>
                </ng-template>
              </p-autoComplete>
              <label for="deliveryCaseHouseBl">House bill</label>
            </p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-building-columns"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-autoComplete inputId="deliveryCaseCustoms" [(ngModel)]="form.customsDeclarationNumber" [suggestions]="referenceSuggestions.CUSTOMS_DECLARATION"
                optionLabel="value" optionValue="value" [dropdown]="true" [forceSelection]="false" [minLength]="0" appendTo="body" styleClass="w-full"
                (completeMethod)="searchReferences('CUSTOMS_DECLARATION', $event.query)" (onSelect)="applyReferenceSuggestion($event.value)">
                <ng-template let-reference pTemplate="item">
                  <div class="delivery-container-reference-option">
                    <strong>{{ reference.value }}</strong>
                    <small>{{ reference.billOfLadingNumber || reference.bookingNumber || 'Existing customs declaration' }}</small>
                  </div>
                </ng-template>
              </p-autoComplete>
              <label for="deliveryCaseCustoms">Customs declaration</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </div>

      <div class="delivery-container-case-section">
        <div class="delivery-container-case-section-title"><i class="pi pi-sitemap"></i><span>Journey seed</span></div>
        <div class="delivery-container-case-form-grid two-columns">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="deliveryCaseTransportMode" [options]="transportModeOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.transportMode" appendTo="body" styleClass="w-full"></p-select>
              <label for="deliveryCaseTransportMode">Delivery movement mode</label>
            </p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="deliveryCaseJourneyTemplate" [options]="journeyProfileOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="form.journeyTemplateId" [loading]="journeyProfilesLoading" [filter]="true" filterBy="label"
                [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
              <label for="deliveryCaseJourneyTemplate">Equipment journey plan *</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        @if (selectedJourneyProfile(); as profile) {
          <div class="delivery-container-case-profile-summary">
            <i class="pi pi-sitemap"></i>
            <div><strong>{{ profile.label }}</strong><span>{{ profile.description }} · {{ profile.stepCount }} planned steps</span></div>
          </div>
        } @else {
          <div class="delivery-container-case-profile-empty required">
            Select the required equipment journey plan to add its downstream transport and storage steps after the delivery seed.
          </div>
        }
      </div>
    </section>
  </div>

  <ng-template pTemplate="footer">
    <div class="delivery-container-case-footer">
      <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="reset()" [disabled]="creating"></p-button>
      <span class="footer-spacer"></span>
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="close()" [disabled]="creating"></p-button>
      <p-button label="Create Case & Seed Journey" icon="pi pi-sitemap" (onClick)="create()"
        [disabled]="!form.containerNumber?.trim() || !hasCommercialReference() || !form.journeyTemplateId" [loading]="creating"></p-button>
    </div>
  </ng-template>
</p-dialog>
